import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Services.css";
import SEO from "../SEO";
export default function Services() {
  React.useEffect(() => {
    AOS.init({ once: true, duration: 800 });
  }, []);

  const services = [
    {
      title: "Custom Software Development",
      desc: "Scalable, secure, and enterprise-grade solutions using .NET, Java, and modern architectures.",
      icon: "💻",
      features: [
        "Enterprise Solutions",
        "Scalable Architecture",
        "Clean Code",
        "Full Testing",
      ],
    },
    {
      title: "POS & ERP Systems",
      desc: "End-to-end inventory management, POS, and accounting systems tailored to your needs.",
      icon: "🛒",
      features: [
        "Inventory Management",
        "Point of Sale",
        "Financial Reporting",
        "Multi-store Support",
      ],
    },
    {
      title: "Web & E-Commerce",
      desc: "Fast, SEO-friendly websites and e-commerce platforms built for conversions.",
      icon: "🌐",
      features: [
        "Responsive Design",
        "SEO Optimized",
        "Payment Integration",
        "Performance Tuned",
      ],
    },
    {
      title: "Cloud & DevOps",
      desc: "Cloud-ready infrastructure, APIs, and deployments on AWS, Azure, and Kubernetes.",
      icon: "☁️",
      features: [
        "AWS/Azure Setup",
        "CI/CD Pipelines",
        "Docker & Kubernetes",
        "24/7 Monitoring",
      ],
    },
    {
      title: "Mobile App Development",
      desc: "Cross-platform mobile apps with React Native and Flutter for iOS & Android.",
      icon: "📱",
      features: [
        "iOS & Android",
        "Cross-Platform",
        "Native Performance",
        "App Store Ready",
      ],
    },
    {
      title: "AI & Machine Learning",
      desc: "AI-powered solutions, chatbots, and intelligent automation for your business.",
      icon: "🤖",
      features: [
        "AI Chatbots",
        "Data Analytics",
        "Automation",
        "Predictive Models",
      ],
    },
  ];

  return (
    <>
      <SEO
        title="Our Services – MZR Software"
        description="Explore our services including ERP, Cloud DevOps, Mobile Development, AI Solutions, and Custom Software."
        image="https://mzrsoftware.com/assets/images/og-services.jpg"
        url="https://mzrsoftware.com/OurServices/index"
      />
      <section className="services-section">
        <div className="container">
          <div className="section-header text-center mb-5">
            <h1 className="section-title" data-aos="fade-up">
              Our <span className="highlight">Services</span>
            </h1>
            <p
              className="section-subtitle"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Comprehensive software solutions for modern businesses
            </p>
          </div>

          <div className="services-grid">
            {services.map((service, index) => (
              <div
                key={index}
                className="service-card"
                data-aos="flip-left"
                data-aos-delay={index * 50}
              >
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
                <div className="service-features">
                  {service.features.map((feature, i) => (
                    <span key={i} className="feature-tag">
                      ✓ {feature}
                    </span>
                  ))}
                </div>
                <a href="#contact" className="service-link">
                  Learn More →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
